import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";

import { primaryColor } from "../../../../../utility/constants/colorManager";
import { STATUS_CODE_200 } from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";

import { useLocation } from "react-router-dom";

const CheckBoxWithName = ({ title, value, onChange, checked = false }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: 30,
        width: "auto",
        margin: "0px 10px",
      }}
    >
      <input
        type="checkbox"
        style={{
          height: 20,
          width: 20,
          marginRight: 20,
        }}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <p
        style={{
          fontSize: 14,
        }}
      >
        {title}
      </p>
    </div>
  );
};

function EditAcl({
  onClickCancel,
  edit = false,
  role,
  aclFeatures,
  // userId,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const {
    state: { data },
  } = useLocation();
  const [selectedRole, setSelectedRole] = useState("");
  const [allRolesDropdown, setAllRolesDropdown] = useState([]);
  const [aclList, setAclList] = useState([]);
  const [aclListChecked, setAclListChecked] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [userId, setUserId] = useState("");

  const [userAclList, setUserAclList] = useState([]);

  const findAclById = (id) => {
    let obj = userAclList.findIndex((o) => {
      return o.acl_id === id || o.aclId === id;
    });

    return obj !== -1;
  };

  const findSubAclById = (id, aclId) => {
    const index = userAclList.findIndex((o) => {
      return o.acl_id === aclId || o.aclId === aclId;
    });

    if (index !== -1) {
      let obj = userAclList[index]?.subaclList?.findIndex((o) => {
        return o.sub_acl_id === id || o.subAclId === id;
      });
      return obj !== -1;
    } else return false;
  };

  const removeByAclId = (id) => {
    const filteredData = userAclList.filter((obj) => {
      return obj.acl_id !== id && obj.aclId !== id;
    });

    setUserAclList(filteredData);
  };

  const removeBySubAclId = (aclId, id) => {
    const index = userAclList.findIndex((o) => {
      return o.acl_id === aclId;
    });
    const filteredData = userAclList[index]?.subaclList?.filter((p) => {
      return p.sub_acl_id !== id && p.subAclId !== id;
    });

    let temp = userAclList[index];
    const filteredData1 = userAclList.filter((q) => {
      return q.acl_id !== aclId && q.aclId !== aclId;
    });

    if (filteredData?.length === 0) {
      setUserAclList([...filteredData1]);
    } else {
      setUserAclList([
        ...filteredData1,
        {
          acl_name: temp.acl_name,
          acl_id: temp.acl_id,
          subaclList: filteredData,
          acl_value: temp.acl_value,
        },
      ]);
    }
  };

  // either the id is wrong
  // or the userAclList is not updating

  const addSubAclToArray = (aclId, id, name, value, path) => {
    const filteredData = userAclList.filter((o) => {
      return o.acl_id === aclId;
    });

    filteredData[0].subaclList.push({
      sub_acl_id: id,
      sub_acl_name: name,
      sub_acl_value: value,
      api_path_value: path,
    });

    setUserAclList([...userAclList]);
  };

  useEffect(() => {
    getAclList();
  }, []);

  const filteredAcl = aclList;

  // auto check the checkbox based on roles

  const fetchAllUiAcl = () => {
    ApiRequestGet.getAllAclForUi()
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          setAclList(response.data.acls);
        }
        const excludedAclNames = [
          "Risk Management",
          "Approval",
          "Reseller",
          "Client",
          "Commission List",
          "Role Management",
        ];
        const excludedSubAclNames = [
          "All",
          "Failed",
          "Refund",
          "Revenue",
          "Client Settlement",
          "Van Settlement",
          "Revenue Report",
          "Transfer",
          "User Count",
        ];

        const filteredAclList = response.data.acls.filter(
          (obj) => !excludedAclNames.includes(obj.acl_name)
        );

        let modifiedList = [];

        const subAclsForClient = filteredAclList.map((acl) => {
          const List = acl.aclList.filter(
            (subAcl) => !excludedSubAclNames.includes(subAcl.sub_acl_name)
          );

          modifiedList.push({
            ...acl,
            aclList: List,
          });
          return modifiedList;
        });
        setAclList(modifiedList);
      })
      .catch((err) => {});
  };

  const editUser = () => {
    ApiRequestPost.updateAclmanagement({
      // role: selectedRole.label,
      aclList: userAclList,
      userId: data?.userId,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          navigate("/clients", { replace: true });
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getAclList = () => {
    ApiRequestGet.getAclList({
      user_id: data?.userId,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          const tempData = response.data.aclList;
          delete tempData._id;
          setUserAclList(tempData);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    setFirstName(data?.firstName);
    setLastName(data?.lastName);
    setEmail(data?.email);
    setMobileNumber(data?.mobileNumber);
    setUserId(data?.userId);
  }, [data]);

  useEffect(() => {
    fetchAllUiAcl();
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: 700,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        maxWidth: "1000px",
        minWidth: "400px",
        margin: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          height: 60,
          position: "absolute",
          top: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            height: "auto",
            height: 60,
            alignItems: "center",
          }}
        >
          <p
            style={{
              marginRight: 30,
              fontSize: 17,
              fontWeight: "600",
            }}
          >
            Acl Management
          </p>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          height: "80%",
          flexDirection: "column",
          overflow: "auto",
          marginTop: 60,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            padding: "15px 0px",
            border: "1px solid #F3F3F3",
            backgroundColor: "#F9F9FB",
            marginTop: "20px",
          }}
        >
          <div
            style={{
              margin: "0px 30px",
              width: 200,
              minWidth: 200,
            }}
          >
            <p>Tab</p>
          </div>
          <div
            style={{
              margin: "0px 0px",
            }}
          >
            <p>Actions</p>
          </div>
        </div>

        {aclList &&
          aclList?.map((obj, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "0px 0px",
                padding: "15px 0px",
                borderBottom: "1px solid #F3F3F3",
              }}
            >
              <div
                style={{
                  margin: "0px 20px",
                  width: 200,
                  minWidth: 200,
                }}
              >
                <CheckBoxWithName
                  title={obj?.acl_name}
                  value={obj.acl_id}
                  onChange={() => {
                    if (findAclById(obj.acl_id)) {
                      removeByAclId(obj.acl_id);
                    } else {
                      let temp = [];
                      obj.aclList.forEach((subacl) => {
                        temp.push({
                          sub_acl_id: subacl.sub_acl_id,
                          sub_acl_name: subacl.sub_acl_name,
                          sub_acl_value: subacl.sub_acl_value,
                          api_path_value: subacl.api_path_value,
                        });
                      });
                      setUserAclList([
                        ...userAclList,

                        {
                          acl_id: obj.acl_id,
                          acl_name: obj.acl_name,
                          subaclList: temp,
                          acl_value: obj.acl_value,
                        },
                      ]);
                    }
                  }}
                  checked={findAclById(obj.acl_id)}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                {obj?.aclList &&
                  obj?.aclList.map((obj1, i1) => (
                    <CheckBoxWithName
                      key={i1}
                      title={obj1?.sub_acl_name}
                      value={obj1.sub_acl_id}
                      onChange={() => {
                        if (findSubAclById(obj1.sub_acl_id, obj.acl_id)) {
                          removeBySubAclId(obj.acl_id, obj1.sub_acl_id);
                        } else if (findAclById(obj.acl_id)) {
                          addSubAclToArray(
                            obj.acl_id,
                            obj1.sub_acl_id,
                            obj1.sub_acl_name,
                            obj1.sub_acl_value,
                            obj1.api_path_value
                          );
                        } else {
                          setUserAclList([
                            ...userAclList,
                            {
                              acl_id: obj.acl_id,
                              acl_name: obj.acl_name,
                              acl_value: obj.acl_value,
                              subaclList: [
                                {
                                  sub_acl_id: obj1.sub_acl_id,
                                  sub_acl_name: obj1.sub_acl_name,
                                  sub_acl_value: obj1.sub_acl_value,
                                  api_path_value: obj1.api_path_value,
                                },
                              ],
                            },
                          ]);
                        }
                      }}
                      checked={findSubAclById(obj1.sub_acl_id, obj.acl_id)}
                    />
                  ))}
              </div>
            </div>
          ))}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          padding: "15px 0px",
          marginTop: "10px",
          position: "absolute",
          bottom: 0,
        }}
      >
        <CustomButton
          title={"Cancel"}
          styles={{
            backgroundColor: "transparent",
            border: `1px solid ${primaryColor}`,
          }}
          textStyles={{ color: primaryColor }}
          onClick={() => {
            navigate("/clients", { replace: true });
          }}
        />
        <CustomButton
          title={"Save"}
          styles={{
            backgroundColor: primaryColor,
            border: `1px solid ${primaryColor}`,
            marginLeft: "20px",
          }}
          textStyles={{ color: "white" }}
          onClick={() => {
            editUser();
          }}
          loading={loading}
        />
      </div>
    </div>
  );
}

export default EditAcl;
